import React, { useState } from 'react'
import { useSelector } from 'react-redux';

function AddVariableDropdown({ addedVariable, stateVariable }) {
  const variables = useSelector(state => state?.variablesReducer);
 

  return (
    <>
      <div className="header-dropdown variable-dropdown dropdown-toggle noselect " id="header-share-dropdown" data-bs-toggle="dropdown" aria-expanded="false">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M3.25 6.5L3.64223 7.28446C3.77497 7.54995 3.84135 7.68269 3.93002 7.79772C4.0087 7.8998 4.1002 7.9913 4.20228 8.06998C4.31731 8.15865 4.45005 8.22503 4.71554 8.35777L5.5 8.75L4.71554 9.14223C4.45005 9.27497 4.31731 9.34135 4.20228 9.43002C4.1002 9.5087 4.0087 9.6002 3.93002 9.70228C3.84135 9.81731 3.77497 9.95005 3.64223 10.2155L3.25 11L2.85777 10.2155C2.72503 9.95005 2.65865 9.81731 2.56998 9.70228C2.4913 9.6002 2.3998 9.5087 2.29772 9.43002C2.18269 9.34135 2.04995 9.27497 1.78446 9.14223L1 8.75L1.78446 8.35777C2.04995 8.22503 2.18269 8.15865 2.29772 8.06998C2.3998 7.9913 2.4913 7.8998 2.56998 7.79772C2.65865 7.68269 2.72503 7.54995 2.85777 7.28446L3.25 6.5Z" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M7.5 1L8.08931 2.53221C8.23032 2.89882 8.30082 3.08213 8.41046 3.23632C8.50763 3.37298 8.62702 3.49237 8.76368 3.58954C8.91787 3.69918 9.10118 3.76968 9.46779 3.91069L11 4.5L9.46779 5.08931C9.10118 5.23032 8.91787 5.30082 8.76368 5.41046C8.62702 5.50763 8.50763 5.62702 8.41046 5.76368C8.30082 5.91787 8.23032 6.10118 8.08931 6.46779L7.5 8L6.91069 6.46779C6.76968 6.10118 6.69918 5.91787 6.58954 5.76368C6.49237 5.62702 6.37298 5.50763 6.23632 5.41046C6.08213 5.30082 5.89882 5.23032 5.53221 5.08931L4 4.5L5.53221 3.91069C5.89882 3.76968 6.08213 3.69918 6.23632 3.58954C6.37298 3.49237 6.49237 3.37298 6.58954 3.23632C6.69918 3.08213 6.76968 2.89882 6.91069 2.53221L7.5 1Z" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      <span>
        Variable
      </span>
      </div>
      <ul className="dropdown-menu share-dropdown" style={{ borderRadius: "15px" }} aria-labelledby="header-share-dropdown">
        {
          variables?.map((val, index) => (
            <li className='w-100' key={index}>
              <div onClick={() => addedVariable('(('+val+'))', stateVariable)} className="share-dropdown-item share-dropdown-text d-flex justify-content-start align-items-center" >
                {val}
              </div>
            </li>

          ))
        }
      </ul>
    </>
  )
}

export default AddVariableDropdown